module.exports = __webpack_public_path__ + "img/流程设计_02.a2b0b4af.svg";